import cn from 'classnames';
import React from 'react';

import Info from '@sats-group/icons/16/info';
import Checkbox from '@sats-group/ui-lib/react/checkbox/checkbox';
import Tag from '@sats-group/ui-lib/react/tag/tag';
import Text from '@sats-group/ui-lib/react/text';

import type { Addon as Props } from './addon.props';

export const Addon: React.FC<Props> = ({
  checkbox,
  description,
  disclaimer,
  highlight = false,
  onClick,
  price,
}) => {
  return (
    <div
      className={cn('addon', { 'addon--highlight': highlight })}
      onClick={onClick}
    >
      <div className="addon__body">
        <div className="addon__header">
          {checkbox ? (
            <Checkbox
              labelVariant={
                highlight
                  ? Checkbox.labelVariants.headline
                  : Checkbox.labelVariants.bold
              }
              theme={highlight ? Checkbox.themes.light : Checkbox.themes.blue}
              {...checkbox}
            />
          ) : null}
          <div className="addon__tag">
            {price ? (
              <Tag
                variant={
                  highlight ? Tag.variants.positive : Tag.variants.secondary
                }
                theme={highlight ? Tag.themes.fixed : Tag.themes.light}
                size={Tag.sizes.xs}
                {...price}
              />
            ) : null}
          </div>
        </div>
        {description ? (
          <Text className="addon__description" size={Text.sizes.small}>
            {description}
          </Text>
        ) : null}
      </div>
      {disclaimer && checkbox.defaultChecked ? (
        <div className="addon__disclaimer">
          <Info />
          <Text size={Text.sizes.interface}>{disclaimer}</Text>
        </div>
      ) : null}
    </div>
  );
};

export default Addon;
